import {
  MESSAGES_ARCHIVE
} from "../actions/messagesActions";
import {
  MESSAGE_DETAIL_ADD_RESPONSE, MESSAGE_DETAIL_ERROR, MESSAGE_DETAIL_LOADING,
  MESSAGE_DETAIL_UPDATE
} from "../actions/messageDetailActions";

const INITIAL_STATE = {
  message: null,
  messageLoading: false,
  messageError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MESSAGE_DETAIL_UPDATE:
      return {
        ...state,
        message: action.payload.data,
        messageError: action.payload.message,
      };
    case MESSAGE_DETAIL_ERROR:
      return {
        ...state,
        messageError: action.payload,
      };
    case MESSAGE_DETAIL_LOADING:
      return {
        ...state,
        messageLoading: action.payload,
      };
    case MESSAGE_DETAIL_ADD_RESPONSE:
      const message = {...state.message};
      if (message.id.toString() === action.id.toString()){
        // Añadimos el mensaje
        message.children.push(action.payload);
        // Marcamos como activo el mensaje y sus hijos
        message.active = true;
        message.children.forEach((messageChildren) => {
          messageChildren.active = true;
        });
        return {
          ...state,
          message: message,
        };
      } else {
        return {...state};
      }
    case MESSAGES_ARCHIVE:
      const messageArchive = {...state.message};
      if (messageArchive.id === action.id){
        messageArchive.active = false;
        messageArchive.children.forEach((messageChildren) => {
          messageChildren.active = false;
        });
        return {
          ...state,
          message: messageArchive,
        };
      } else {
        return {...state};
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/reducer/MessageDetailReducer.js